module.exports = __webpack_public_path__ + "static/media/Main.6fb37f4a.png";